export const MAP_KEYS = {
    yandex: 'yandex#map',
    gis: '2gis#map',
}
